import { BetMultiple } from 'src/app/models/bet-multiple.interface';

export interface IBetMultipleState {
  betmultiple: BetMultiple;
}

export const initialBetMultipleState: IBetMultipleState = {
  betmultiple: null
};
